import type { PermissionCategory } from './types';

export const sortCategories = (
  categories: PermissionCategory[],
  categoryId: number,
  sort: string,
  order: string,
  originalCategoriesOrder: Map<number, PermissionCategory>
): PermissionCategory[] => {
  if (!sort || !order) {
    const originalCategory = originalCategoriesOrder.get(categoryId);
    if (originalCategory) {
      return categories.map((category) =>
        category.id === categoryId
          ? { ...category, positions: [...originalCategory.positions] }
          : category
      );
    }
    return categories;
  }

  if (!originalCategoriesOrder.has(categoryId)) {
    const categoryToSave = categories.find((cat) => cat.id === categoryId);
    if (categoryToSave) {
      originalCategoriesOrder.set(categoryId, {
        ...categoryToSave,
        positions: [...categoryToSave.positions],
      });
    }
  }

  const sortMultiplier = order === 'asc' ? 1 : -1;

  return categories.map((category) => {
    if (category.id !== categoryId) {
      return category;
    }

    const sortedPositions = [...category.positions].sort((a, b) => {
      if (sort === 'name') {
        return sortMultiplier * a.name.localeCompare(b.name, 'pt-BR');
      }

      if (sort === 'createdAt') {
        const aDate = a.createdAt ? new Date(a.createdAt).getTime() : 0;
        const bDate = b.createdAt ? new Date(b.createdAt).getTime() : 0;
        return sortMultiplier * (aDate - bDate);
      }

      return 0;
    });

    return {
      ...category,
      positions: sortedPositions,
    };
  });
};
